import { LIQUIDITY_POOLS_CONFIG } from '@/src/utils/tokens';
import { LiquidityPool } from './types';

export const LIQUIDITY_POOLS: LiquidityPool[] = LIQUIDITY_POOLS_CONFIG;
